window._ = require('lodash');
window.axios = require('axios');

let base_url = document.head.querySelector('meta[name="base-url"]')

if(base_url) {
    axios.defaults.baseURL = base_url.content + (base_url.content.slice(-1) === '/' ? 'api/' : '/api/');
} else {
    throw new Error('AXIOS BASE URL NOT SET');
}

window.axios.defaults.withCredentials = true;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.axios.interceptors.response.use(function (response) {
    return response
}, function (error) {
    if (error.response && error.response.status) {
        if (error.response.status === 401) {
            window.location.assign('/')
        }
        if (error.response.status === 588) {
            window.location.assign('/profile?unverified=1');
        }
    }

    return Promise.reject(error)
});

window.purify = o => JSON.parse(JSON.stringify(o))

let token = document.head.querySelector('meta[name="csrf-token"]')

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
}

let date_format = document.head.querySelector('meta[name="dp-date"]')
let time_format = document.head.querySelector('meta[name="dp-time"]')
let datetime_format = document.head.querySelector('meta[name="dp-datetime"]')
let app_locale = document.head.querySelector('meta[name="app-locale"]')

if (date_format && time_format && datetime_format) {
    window.date_format_moment = date_format.content
    window.time_format_moment = time_format.content
    window.datetime_format_moment = datetime_format.content
    window.app_locale = app_locale.content
} else {
    console.error('Moment.js date and time formats not found')
}


window.fetchFromUrl = function (url, params = null) {
    let genUrl = url;
    if (null !== params) {
        let i = 0;
        for (const [key, value] of Object.entries(params)) {
            if (value) {
                genUrl += ((0 === i) ? '?' : '&');
                if (key.includes('_sort_')) {
                    genUrl += 'sortable[' + key.replace('_sort_', '') + ']=' + value
                } else {
                    genUrl += key + '=' + value
                }
            }
            i++;
        }
    }

    return new Promise(function (resolve, reject) {
        window.axios.get(genUrl)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
    })
};

if (typeof Object.assign !== 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
        value: function assign(target, varArgs) { // .length of function is 2
            'use strict';
            if (target === null || target === undefined) {
                throw new TypeError('Cannot convert undefined or null to object');
            }

            var to = Object(target);

            for (var index = 1; index < arguments.length; index++) {
                var nextSource = arguments[index];

                if (nextSource !== null && nextSource !== undefined) {
                    for (var nextKey in nextSource) {
                        // Avoid bugs when hasOwnProperty is shadowed
                        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
            }
            return to;
        },
        writable: true,
        configurable: true
    });
}


window.generateFetchParams = function (obj1, sortable, extraParams) {
    if (Array.isArray(sortable) && sortable.length > 0) {
        for (let i = 0; i < sortable.length; i++) {
            Object.assign(obj1, sortable[i]);
        }
    }
    Object.assign(obj1, extraParams);
    return obj1;
};

window.keyExistsInObject = function (obj, key) {
    if (obj !== null && typeof obj[key] !== 'undefined' && obj[key] !== null) {
        return true;
    }

    return false;
}

